// import React, { useEffect, useState } from 'react';
// import Button from '@mui/material/Button';
// import AddCameraButton from './components/AddCameraButton';
// import './RightBar.css';
// import {
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   IconButton,
//   Typography,
//   Snackbar,
//   Alert,
//   Drawer,
//   MenuItem,
//   Menu
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { getAllCameras, deleteCamera } from '../../../../api/FM/videoPageApis';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { CloseOutlined } from '@mui/icons-material';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import Switch from '@mui/material/Switch';
// import { MdCameraAlt } from 'react-icons/md';
// import EvidenceList from '../evidencePage/evidenceList';

// const CameraCard = ({ camera, onSelect, isSelected, showEvidenceList }) => {
//   const dispatch = useDispatch();
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);
//   const selectedDate = useSelector((state) => state.customization.currentDate);

//   const zones = useMemo(() => Object.keys(camera?.zones || {}), [camera]);

//   // Responsive breakpoints
//   const [viewportWidth, setViewportWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
//   useEffect(() => {
//     const onResize = () => setViewportWidth(window.innerWidth);
//     window.addEventListener('resize', onResize);
//     return () => window.removeEventListener('resize', onResize);
//   }, []);
//   const isMobile = viewportWidth < 640;
//   const isTablet = viewportWidth >= 640 && viewportWidth < 1024;

//   // Normalize camera active status from various API shapes
//   const isActive = useMemo(() => {
//     if (typeof camera?.active === 'boolean') return camera.active;
//     if (typeof camera?.isActive === 'boolean') return camera.isActive;
//     const s = camera?.status;
//     if (typeof s === 'boolean') return s;
//     if (typeof s === 'string') {
//       const val = s.trim().toLowerCase();
//       return val === 'on' || val === 'active' || val === 'online' || val === 'true' || val === '1';
//     }
//     return false;
//   }, [camera]);

//   // Fetch evidence data when card is expanded and when camera/date changes
//   useEffect(() => {
//     if (selectedDate && camera?.device_name && isExpanded) {
//       fetchEvidenceData();
//     }
//   }, [selectedDate, camera?.device_name, isExpanded]);

//   const fetchEvidenceData = async () => {
//     try {
//       setEvidenceLoading(true);
//       setThumbnails({});
//       setProcessingThumbnails(new Set());
//       setGeneratedThumbnails(new Set());

//       const response = await fetch('https://neoe2e.neophyte.live/fm-api/kpiCreation/evidenceList', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           date: selectedDate,
//           device: camera.device_name
//         })
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setEvidenceData(data || []);
//       }
//     } catch (error) {
//       console.error('Error fetching evidence data:', error);
//     } finally {
//       setEvidenceLoading(false);
//     }
//   };

//   // Generate thumbnail for a specific video
//   const generateThumbnail = useCallback(
//     (videoPath, index) => {
//       if (generatedThumbnails.has(index) || processingThumbnails.has(index) || thumbnails[index]) {
//         return;
//       }

//       setProcessingThumbnails((prev) => new Set([...prev, index]));

//       const video = document.createElement('video');
//       video.src = videoPath;
//       // Remove crossOrigin to avoid CORS issues with Azure blob storage
//       video.preload = 'metadata';
//       video.muted = true;

//       const cleanup = () => {
//         setProcessingThumbnails((prev) => {
//           const newSet = new Set(prev);
//           newSet.delete(index);
//           return newSet;
//         });
//         setGeneratedThumbnails((prev) => new Set([...prev, index]));
//         if (video.timeoutId) clearTimeout(video.timeoutId);
//         video.removeEventListener('loadedmetadata', onLoadedMetadata);
//         video.removeEventListener('seeked', onSeeked);
//         video.removeEventListener('error', onError);
//         video.src = '';
//       };

//       const onLoadedMetadata = () => {
//         video.currentTime = Math.min(2, video.duration * 0.1);
//       };

//       const onSeeked = () => {
//         try {
//           const canvas = document.createElement('canvas');
//           canvas.width = 640;
//           canvas.height = 360;
//           const ctx = canvas.getContext('2d');

//           // Try to draw video frame, fallback to placeholder if CORS error
//           try {
//             ctx.fillStyle = '#000';
//             ctx.fillRect(0, 0, canvas.width, canvas.height);
//             ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//             const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.7);
//             setThumbnails((prev) => ({ ...prev, [index]: thumbnailUrl }));
//             console.log(`Thumbnail generated successfully for index ${index}`);
//           } catch (corsError) {
//             console.log(`CORS error for index ${index}, creating placeholder:`, corsError.message);
//             // Create placeholder thumbnail
//             const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
//             gradient.addColorStop(0, '#2a3359');
//             gradient.addColorStop(1, '#1f2745');
//             ctx.fillStyle = gradient;
//             ctx.fillRect(0, 0, canvas.width, canvas.height);

//             // Add play icon
//             ctx.fillStyle = '#ffffff';
//             ctx.beginPath();
//             const centerX = canvas.width / 2;
//             const centerY = canvas.height / 2;
//             const size = 50;
//             ctx.moveTo(centerX - size / 2, centerY - size / 2);
//             ctx.lineTo(centerX + size / 2, centerY);
//             ctx.lineTo(centerX - size / 2, centerY + size / 2);
//             ctx.closePath();
//             ctx.fill();

//             // Add text
//             ctx.font = 'bold 16px Arial';
//             ctx.textAlign = 'center';
//             ctx.fillStyle = '#ffffff';
//             ctx.fillText('Evidence Video', centerX, centerY + size + 25);

//             const placeholderUrl = canvas.toDataURL('image/jpeg', 0.8);
//             setThumbnails((prev) => ({ ...prev, [index]: placeholderUrl }));
//           }
//         } catch (e) {
//           console.error(`Thumbnail generation error for index ${index}:`, e);
//           setThumbnails((prev) => ({ ...prev, [index]: null }));
//         } finally {
//           cleanup();
//         }
//       };

//       const onError = (e) => {
//         console.log(`Video load error for index ${index}, creating placeholder thumbnail`);
//         // Create placeholder thumbnail when video fails to load
//         try {
//           const canvas = document.createElement('canvas');
//           canvas.width = 640;
//           canvas.height = 360;
//           const ctx = canvas.getContext('2d');

//           // Create gradient background
//           const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
//           gradient.addColorStop(0, '#2a3359');
//           gradient.addColorStop(1, '#1f2745');
//           ctx.fillStyle = gradient;
//           ctx.fillRect(0, 0, canvas.width, canvas.height);

//           // Add play icon
//           ctx.fillStyle = '#ffffff';
//           ctx.beginPath();
//           const centerX = canvas.width / 2;
//           const centerY = canvas.height / 2;
//           const size = 50;
//           ctx.moveTo(centerX - size / 2, centerY - size / 2);
//           ctx.lineTo(centerX + size / 2, centerY);
//           ctx.lineTo(centerX - size / 2, centerY + size / 2);
//           ctx.closePath();
//           ctx.fill();

//           // Add text
//           ctx.font = 'bold 16px Arial';
//           ctx.textAlign = 'center';
//           ctx.fillStyle = '#ffffff';
//           ctx.fillText('Evidence Video', centerX, centerY + size + 25);

//           const placeholderUrl = canvas.toDataURL('image/jpeg', 0.8);
//           setThumbnails((prev) => ({ ...prev, [index]: placeholderUrl }));
//         } catch (canvasError) {
//           console.error(`Canvas error for index ${index}:`, canvasError);
//           setThumbnails((prev) => ({ ...prev, [index]: null }));
//         }
//         cleanup();
//       };

//       video.addEventListener('loadedmetadata', onLoadedMetadata);
//       video.addEventListener('seeked', onSeeked);
//       video.addEventListener('error', onError);

//       // Fail-safe timeout
//       video.timeoutId = setTimeout(() => {
//         setThumbnails((prev) => ({ ...prev, [index]: null }));
//         cleanup();
//       }, 15000);
//     },
//     [thumbnails, processingThumbnails, generatedThumbnails]
//   );

//   const handleFilterChange = (filter) => setEvidenceFilter(filter);

//   // Check camera types
//   const isD03Camera = camera?.device_name === 'D03'; // Has both dock and safety
//   const isD04Camera = camera?.device_name === 'D04'; // Only safety
//   const isD012Camera = camera?.device_name === 'D012'; // Only truck
//   const isD014Camera = camera?.device_name === 'D014'; // Only truck

//   // Filter evidence data based on selected filter
//   const filteredEvidenceData = useMemo(() => {
//     if (!evidenceData.length) return [];

//     if (isD04Camera) return evidenceData.filter((item) => item.type === 'safety');
//     if (isD012Camera || isD014Camera) return evidenceData.filter((item) => item.type === 'truck');

//     if (evidenceFilter === 'safety') return evidenceData.filter((item) => item.type === 'safety');
//     if (evidenceFilter === 'dock') return evidenceData.filter((item) => item.type === 'dock');

//     return evidenceData;
//   }, [evidenceData, evidenceFilter, isD04Camera, isD012Camera, isD014Camera]);

//   // Lazy loading with intersection observer
//   useEffect(() => {
//     if (!filteredEvidenceData.length) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const index = parseInt(entry.target.dataset.index, 10);
//             const evidence = filteredEvidenceData[index];
//             if (evidence?.videos && !generatedThumbnails.has(index) && !processingThumbnails.has(index) && !thumbnails[index]) {
//               generateThumbnail(evidence.videos, index);
//             }
//           }
//         });
//       },
//       {
//         threshold: 0.1,
//         rootMargin: '50px'
//       }
//     );

//     const evidenceItems = document.querySelectorAll('[data-evidence-item]');
//     evidenceItems.forEach((item) => observer.observe(item));

//     return () => observer.disconnect();
//   }, [filteredEvidenceData, generateThumbnail, thumbnails, processingThumbnails, generatedThumbnails]);

//   // Format date helper
//   const formatDate = (dateStr) => {
//     if (!dateStr) return '';
//     return new Date(dateStr).toLocaleString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     });
//   };

//   // Get short type name
//   const getShortType = (type) => {
//     switch ((type || '').toLowerCase()) {
//       case 'dock':
//         return 'Dock';
//       case 'safety':
//         return 'Safety';
//       case 'truck':
//         return 'Truck';
//       default:
//         return type || 'Unknown';
//     }
//   };

//   // Helper function to capitalize text
//   const capitalizeText = (text) => {
//     if (!text) return text;
//     return text
//       .split(' ')
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   // Get status badge content based on camera type and evidence data
//   const getStatusBadge = (evidence, cameraType) => {
//     if (isD012Camera || isD014Camera) {
//       // D012 and D014: render nothing
//       return null;
//     }
    
//     console.log('Camera clicked:', camera);
    
//     // Always update camera data and trigger onSelect
//     dispatch({ type: 'CAMERA_DATA', cameraData: camera });
//     if (onSelect) {
//       onSelect(camera);
//     }
//   };

//   return (
//     <div
//       className={`flex bg-white rounded-lg shadow-lg text-xs p-4 relative hover:shadow-xl transition-all ${
//         isSelected && !showEvidenceList ? 'border-2 border-blue-500 bg-blue-50' : ''
//       } ${!camera.active ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
//       onClick={handleCameraClick}
//     >
//       {/* Left Side: Camera Thumbnail */}
//       <div className="flex w-1/3 items-center justify-center bg-gray-200 rounded-lg overflow-hidden">
//         {camera?.thumbnail ? (
//           <img src={camera?.thumbnail} alt="Camera Thumbnail" className="w-full h-full object-cover" />
//         ) : (
//           <MdCameraAlt className="text-gray-500 text-4xl" />
//         )}
//       </div>

//       {/* Right Side: Camera Info */}
//       <div className="flex flex-col flex-grow px-4">
//         <div className="flex items-center gap-2 mb-2">
//           <h2 className="text-2xl font-semibold">{camera.device_name}</h2>
//           <Switch 
//             checked={camera.active} 
//             onChange={(e) => {
//               e.stopPropagation();
//               handleToggleCamera(camera._id);
//             }} 
//             color="success" 
//           />
//         </div>

//         <div className="flex flex-wrap gap-2 mb-2">
//           {Object.keys(camera.zones || {})
//             .slice(0, 2)
//             .map((zoneName) => (
//               <span key={zoneName} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
//                 {zoneName}
//               </span>
//             ))}
//           {Object.keys(camera.zones || {}).length > 2 && <span className="px-3 py-1 rounded-full text-xs">...</span>}
//         </div>
//       </div>

//       {/* Actions Menu */}
//       <div className="absolute top-2 right-2">
//         <IconButton size="small" onClick={handleMenuClick}>
//           <MoreVertIcon />
//         </IconButton>
//       </div>
//       <Menu
//         anchorEl={anchorEl}
//         open={open}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//         transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//       >
//         <MenuItem onClick={() => console.log('View details')}>Edit</MenuItem>
//         <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
//       </Menu>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={isDeleteModalOpen} onClose={() => !isDeleting && setIsDeleteModalOpen(false)}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to delete this camera? This will also delete all associated zones.</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsDeleteModalOpen(false)} color="primary" disabled={isDeleting}>
//             Cancel
//           </Button>
//           <Button onClick={handleDeleteCamera} color="error" disabled={isDeleting} startIcon={isDeleting && <CircularProgress size={20} />}>
//             {isDeleting ? 'Deleting...' : 'Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// const RightBar = () => {
//   const dispatch = useDispatch();
//   const [cameras, setCameras] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//   const [showEvidenceList, setShowEvidenceList] = useState(false);
//   const cameraAdded = useSelector((state) => state.cameraReducer.cameraAdded);
//   const [error, setError] = useState(null);
//   const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
//   const selectedDate = useSelector((state) => state.customization.currentDate);

//   const fetchCameras = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await getAllCameras();
//       console.log('Fetched cameras response:', response);
//       const camerasArray = response?.cameras || [];
//       console.log('Processed cameras array:', camerasArray);
//       setCameras(camerasArray);
//     } catch (err) {
//       console.error('Error fetching cameras:', err);
//       setError(err.message || 'Failed to fetch cameras');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchEvidenceForAllCameras = async (cams) => {
//     try {
//       const evidencePromises = cams.map(async (cam) => {
//         if (cam?.device_name) {
//           const response = await fetch('https://neoe2e.neophyte.live/fm-api/kpiCreation/evidenceList', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ date: selectedDate, device: cam.device_name })
//           });
//           if (response.ok) {
//             const data = await response.json();
//             return { cameraId: cam._id, evidenceCount: data?.length || 0 };
//           }
//         }
//         return { cameraId: cam._id, evidenceCount: 0 };
//       });

//       const results = await Promise.all(evidencePromises);
//       const countsMap = {};
//       results.forEach((r) => (countsMap[r.cameraId] = r.evidenceCount));
//       setEvidenceCounts(countsMap);
//     } catch (error) {
//       console.error('Error fetching evidence for all cameras:', error);
//     }
//   };

//   useEffect(() => {
//     console.log('selected camera:', selectedCamera);
//     if (selectedDate && selectedCamera?.device_name) {
//       setShowEvidenceList(true);
//     } else {
//       setShowEvidenceList(false);
//     }
//   }, [selectedDate, selectedCamera]);

//   // Reset camera selection when date changes
//   useEffect(() => {
//     if (selectedDate) {
//       dispatch({ type: 'CAMERA_DATA', cameraData: {} }); // Reset camera selection
//       setShowEvidenceList(false); // Hide evidence list until camera is selected
//     }
//   }, [selectedDate, dispatch]);

//   const handleBackToDevices = () => {
//     setShowEvidenceList(false);
//     // Optionally reset camera selection when going back
//     // dispatch({ type: 'CAMERA_DATA', cameraData: {} });
//   };

//   // Check if a camera is currently selected
//   const isCameraSelected = (camera) => {
//     return selectedCamera && selectedCamera._id === camera._id;
//   };

//   return (
//     <>
//       <div className="relative lg:mt-0-mt-[200%]">
//         <IconButton className="absolute top-2 right-2 z-50 md:hidden" onClick={() => setIsDrawerOpen(true)}>
//           <ArrowForwardIcon fontSize="small" style={{ color: 'black' }} />
//         </IconButton>
//       </div>

//       {/* Mobile Drawer */}
//       <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} className="md:hidden">
//         <div className="w-80 p-4 bg-slate-100 border border-gray-300 h-full overflow-y-auto rounded-lg">
//           <IconButton onClick={() => setIsDrawerOpen(false)}>
//             <CloseOutlined fontSize="small" style={{ color: 'black' }} />
//           </IconButton>
//           <div className="p-4">
//             {showEvidenceList ? (
//               <>
//                 <div className="flex items-center mb-4">
//                   <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
//                     <ArrowBackIcon fontSize="small" />
//                   </IconButton>
//                   <Typography variant="h5" className="font-medium">
//                     Evidence - {selectedCamera?.device_name}
//                   </Typography>
//                 </div>
//                 {selectedDate && selectedCamera?.device_name && (
//                   <EvidenceList date={selectedDate} device={selectedCamera} />
//                 )}
//               </>
//             ) : (
//               <>
//                 <div className="flex justify-between items-center mb-4">
//                   <Typography variant="h4" className="font-medium">
//                     Cameras
//                   </Typography>
//                   <AddCameraButton />
//                 </div>

//                 <div className="space-y-4">
//                   {loading ? (
//                     <div className="flex justify-center items-center h-full">
//                       <CircularProgress />
//                     </div>
//                   ) : error ? (
//                     <div className="flex justify-center items-center h-full">
//                       <Typography variant="body1" color="error">
//                         {error}
//                       </Typography>
//                     </div>
//                   ) : cameras.length === 0 ? (
//                     <div className="flex justify-center items-center h-full">
//                       <Typography variant="body1" color="textSecondary">
//                         No cameras found
//                       </Typography>
//                     </div>
//                   ) : (
//                     cameras
//                       .slice()
//                       .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
//                       .map((camera) => (
//                         <CameraCard 
//                           key={camera._id} 
//                           camera={camera} 
//                           onSelect={handleCameraSelect}
//                           isSelected={isCameraSelected(camera)}
//                           showEvidenceList={showEvidenceList}
//                         />
//                       ))
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </Drawer>

//       {/* Desktop View */}
//       <div className="hidden md:block bg-slate-100 border border-gray-300 h-full w-full overflow-y-auto rounded-lg">
//         <div className="p-4">
//           {showEvidenceList ? (
//             <>
//               <div className="flex items-center mb-4">
//                 <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
//                   <ArrowBackIcon fontSize="small" />
//                 </IconButton>
//                 <Typography variant="h5" className="font-medium">
//                   Evidence - {selectedCamera?.device_name}
//                 </Typography>
//               </div>
//               {selectedDate && selectedCamera?.device_name && (
//                 <EvidenceList date={selectedDate} device={selectedCamera} />
//               )}
//             </>
//           ) : (
//             <>
//               <div className="flex justify-between items-center mb-4">
//                 <Typography variant="h5" className="font-medium">
//                   Cameras
//                 </Typography>
//                 <AddCameraButton />
//               </div>

//               <div className="space-y-4">
//                 {loading ? (
//                   <div className="flex justify-center items-center h-full">
//                     <CircularProgress />
//                   </div>
//                 ) : error ? (
//                   <div className="flex justify-center items-center h-full">
//                     <Typography variant="body1" color="error">
//                       {error}
//                     </Typography>
//                   </div>
//                 ) : cameras.length === 0 ? (
//                   <div className="flex justify-center items-center h-full">
//                     <Typography variant="body1" color="textSecondary">
//                       No cameras found
//                     </Typography>
//                   </div>
//                 ) : (
//                   cameras
//                     .slice()
//                     .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
//                     .map((camera) => (
//                       <CameraCard 
//                         key={camera._id} 
//                         camera={camera} 
//                         onSelect={handleCameraSelect}
//                         isSelected={isCameraSelected(camera)}
//                         showEvidenceList={showEvidenceList}
//                       />
//                     ))
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default RightBar;


import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import AddCameraButton from './components/AddCameraButton';
import './RightBar.css';
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Typography,
  Snackbar,
  Alert,
  Drawer,
  MenuItem,
  Menu
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCameras, deleteCamera } from '../../../../api/FM/videoPageApis';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CloseOutlined } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Switch from '@mui/material/Switch';
import { MdCameraAlt } from 'react-icons/md';
import EvidenceList from '../evidencePage/evidenceList';
import CameraThumbnail from '../../../../assets/images/camera_thumbnail1.jpg';

const CameraCard = ({ camera, onSelect, isSelected, showEvidenceList }) => {
  const dispatch = useDispatch();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleDeleteCamera = async () => {
    try {
      setIsDeleting(true);
      await deleteCamera(camera._id);
      dispatch({ type: 'CAMERA_ADDED' });
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
      setSnackbar({
        open: true,
        message: 'Camera deleted successfully',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.message || 'Failed to delete camera',
        severity: 'error'
      });
    } finally {
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (videoPlaying) {
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
    }
    setIsDeleteModalOpen(true);
  };

  const handleToggleCamera = (cameraId) => {
    // Implement your camera toggle logic here
    console.log('Toggle camera', cameraId);
  };

  const handleCameraClick = () => {
    if (!camera.active) {
      return;
    }
    
    console.log('Camera clicked:', camera);
    
    // Always update camera data and trigger onSelect
    dispatch({ type: 'CAMERA_DATA', cameraData: camera });
    if (onSelect) {
      onSelect(camera);
    }
  };

  return (
    <div
      className={`flex bg-white rounded-lg shadow-lg text-xs p-4 relative hover:shadow-xl transition-all ${
        isSelected && !showEvidenceList ? 'border-2 border-blue-500 bg-blue-50' : ''
      } ${!camera.active ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
      onClick={handleCameraClick}
    >
      {/* Left Side: Camera Thumbnail */}
      <div className="flex w-1/3 items-center justify-center bg-gray-200 rounded-lg overflow-hidden">
        {camera?.thumbnail ? (
          <img src={CameraThumbnail} alt="Camera Thumbnail" className="w-full h-full object-cover" />
        ) : (
          <MdCameraAlt className="text-gray-500 text-4xl" />
        )}
      </div>

      {/* Right Side: Camera Info */}
      <div className="flex flex-col flex-grow px-4">
        <div className="flex items-center gap-2 mb-2">
          <h2 className="text-2xl font-semibold">{camera.device_name}</h2>
          <Switch 
            checked={camera.active} 
            onChange={(e) => {
              e.stopPropagation();
              handleToggleCamera(camera._id);
            }} 
            color="success" 
          />
        </div>

        <div className="flex flex-wrap gap-2 mb-2">
          {Object.keys(camera.zones || {})
            .slice(0, 2)
            .map((zoneName) => (
              <span key={zoneName} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                {zoneName}
              </span>
            ))}
          {Object.keys(camera.zones || {}).length > 2 && <span className="px-3 py-1 rounded-full text-xs">...</span>}
        </div>
      </div>

      {/* Actions Menu */}
      <div className="absolute top-2 right-2">
        <IconButton size="small" onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => console.log('View details')}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog open={isDeleteModalOpen} onClose={() => !isDeleting && setIsDeleteModalOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this camera? This will also delete all associated zones.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteModalOpen(false)} color="primary" disabled={isDeleting}>
            Cancel
          </Button>
          <Button onClick={handleDeleteCamera} color="error" disabled={isDeleting} startIcon={isDeleting && <CircularProgress size={20} />}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const RightBar = () => {
  const dispatch = useDispatch();
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showEvidenceList, setShowEvidenceList] = useState(false);
  const cameraAdded = useSelector((state) => state.cameraReducer.cameraAdded);
  const [error, setError] = useState(null);
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const selectedDate = useSelector((state) => state.customization.currentDate);

  const fetchCameras = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllCameras();
      console.log('Fetched cameras response:', response);
      const camerasArray = response?.cameras || [];
      console.log('Processed cameras array:', camerasArray);
      setCameras(camerasArray);
    } catch (err) {
      console.error('Error fetching cameras:', err);
      setError(err.message || 'Failed to fetch cameras');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('cameraAdded state changed:', cameraAdded);
    fetchCameras();
    // Reset cameraAdded flag after fetching
    if (cameraAdded) {
      dispatch({ type: 'RESET_CAMERA_ADDED' });
    }
  }, [cameraAdded, dispatch]);

  // Handle camera selection and evidence list display
  const handleCameraSelect = (camera) => {
    if (selectedDate && camera?.device_name) {
      setShowEvidenceList(true);
    }
  };

  // Show evidence list when both date and camera are selected
  useEffect(() => {
    console.log('selected camera:', selectedCamera);
    if (selectedDate && selectedCamera?.device_name) {
      setShowEvidenceList(true);
    } else {
      setShowEvidenceList(false);
    }
  }, [selectedDate, selectedCamera]);

  // Reset camera selection when date changes
  useEffect(() => {
    if (selectedDate) {
      dispatch({ type: 'CAMERA_DATA', cameraData: {} }); // Reset camera selection
      setShowEvidenceList(false); // Hide evidence list until camera is selected
    }
  }, [selectedDate, dispatch]);

  const handleBackToDevices = () => {
    setShowEvidenceList(false);
    // Optionally reset camera selection when going back
    // dispatch({ type: 'CAMERA_DATA', cameraData: {} });
  };

  // Check if a camera is currently selected
  const isCameraSelected = (camera) => {
    return selectedCamera && selectedCamera._id === camera._id;
  };

  return (
    <>
      <div className="relative lg:mt-0-mt-[200%]">
        <IconButton className="absolute top-2 right-2 z-50 md:hidden" onClick={() => setIsDrawerOpen(true)}>
          <ArrowForwardIcon fontSize="small" style={{ color: 'black' }} />
        </IconButton>
      </div>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} className="md:hidden">
        <div className="w-80 p-4 bg-slate-100 border border-gray-300 h-full overflow-y-auto rounded-lg">
          <IconButton onClick={() => setIsDrawerOpen(false)}>
            <CloseOutlined fontSize="small" style={{ color: 'black' }} />
          </IconButton>
          <div className="p-4">
            {showEvidenceList ? (
              <>
                <div className="flex items-center mb-4">
                  <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
                    <ArrowBackIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="h5" className="font-medium">
                    Evidence - {selectedCamera?.device_name}
                  </Typography>
                </div>
                {selectedDate && selectedCamera?.device_name && (
                  <EvidenceList date={selectedDate} device={selectedCamera} />
                )}
              </>
            ) : (
              <>
                <div className="flex justify-between items-center mb-4">
                  <Typography variant="h4" className="font-medium">
                    Cameras
                  </Typography>
                  <AddCameraButton />
                </div>

                <div className="space-y-4">
                  {loading ? (
                    <div className="flex justify-center items-center h-full">
                      <CircularProgress />
                    </div>
                  ) : error ? (
                    <div className="flex justify-center items-center h-full">
                      <Typography variant="body1" color="error">
                        {error}
                      </Typography>
                    </div>
                  ) : cameras.length === 0 ? (
                    <div className="flex justify-center items-center h-full">
                      <Typography variant="body1" color="textSecondary">
                        No cameras found
                      </Typography>
                    </div>
                  ) : (
                    cameras
                      .slice()
                      .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                      .map((camera) => (
                        <CameraCard 
                          key={camera._id} 
                          camera={camera} 
                          onSelect={handleCameraSelect}
                          isSelected={isCameraSelected(camera)}
                          showEvidenceList={showEvidenceList}
                        />
                      ))
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Drawer>

      {/* Desktop View */}
      <div className="hidden md:block bg-slate-100 border border-gray-300 h-full w-full overflow-y-auto rounded-lg">
        <div className="p-4">
          {showEvidenceList ? (
            <>
              <div className="flex items-center mb-4">
                <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
                <Typography variant="h5" className="font-medium">
                  Evidence - {selectedCamera?.device_name}
                </Typography>
              </div>
              {selectedDate && selectedCamera?.device_name && (
                <EvidenceList date={selectedDate} device={selectedCamera} />
              )}
            </>
          ) : (
            <>
              <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" className="font-medium">
                  Cameras
                </Typography>
                <AddCameraButton />
              </div>

              <div className="space-y-4">
                {loading ? (
                  <div className="flex justify-center items-center h-full">
                    <CircularProgress />
                  </div>
                ) : error ? (
                  <div className="flex justify-center items-center h-full">
                    <Typography variant="body1" color="error">
                      {error}
                    </Typography>
                  </div>
                ) : cameras.length === 0 ? (
                  <div className="flex justify-center items-center h-full">
                    <Typography variant="body1" color="textSecondary">
                      No cameras found
                    </Typography>
                  </div>
                ) : (
                  cameras
                    .slice()
                    .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                    .map((camera) => (
                      <CameraCard 
                        key={camera._id} 
                        camera={camera} 
                        onSelect={handleCameraSelect}
                        isSelected={isCameraSelected(camera)}
                        showEvidenceList={showEvidenceList}
                      />
                    ))
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RightBar;